// extracted by mini-css-extract-plugin
module.exports = {"page":"PageLayout_page__yeRfd","common":"PageLayout_common__q_6We","containerSmall":"PageLayout_containerSmall__QPt6y","containerLarge":"PageLayout_containerLarge__1NoZW"};